document.addEventListener("DOMContentLoaded", function() {
  var hamburger = document.querySelector(".hamburger-menu");
  var navMenu = document.querySelector(".nav-menu"); // Adjust this selector to match your navigation menu

  hamburger.addEventListener("click", function() {
    hamburger.classList.toggle("active");
    navMenu.classList.toggle("active"); // Toggle class to show/hide the menu
  });
});
